import createLucideIcon from '../createLucideIcon';

const History = createLucideIcon('HistoryIcon', [
  ['path', { d: 'M3 3v5h5', key: '1xhq8a' }],
  ['path', { d: 'M3.05 13A9 9 0 1 0 6 5.3L3 8', key: '1xoms2' }],
  ['path', { d: 'M12 7v5l4 2', key: '1fdv2h' }],
]);

export default History;
